import React from "react";
import BrandLeaderBoardModule from "./BrandLeaderBoardModule";
import BrandLeaderBoardSagas from "./redux/BrandLeaderBoardSagas";
import BrandLeaderBoardReducer from "./redux/BrandLeaderBoardReducer";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Brand Leaderboard",
  moduleList: [
    {
      Component: BrandLeaderBoardModule,
      moduleName: "brandLeaderboard",
      saga: BrandLeaderBoardSagas(),
      reducer: BrandLeaderBoardReducer
    }
  ],
  hideConfigurator: true
};

const BrandLeaderBoardPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default BrandLeaderBoardPage;
